import React from 'react';
import * as S from './styles';

// Botão de aba com ícone + título em cima e descrição centralizada embaixo, usado nos
// seletores "Produtores" / "Locais de aplicação" dos modais de importação. Esconde a
// descrição em telas <=480px (ver styles.js) pra não sobrepor o sublinhado da aba.
const TabTitle = ({ icon, title, description, active, onClick, type = 'button' }) => (
  <S.Tab type={type} active={active} onClick={onClick}>
    <b>
      {icon}
      {title}
    </b>
    {description && <span>{description}</span>}
  </S.Tab>
);

export default TabTitle;
